var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-group"
  }, [_vm.backButtonIsVisible ? _c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function click($event) {
        return _vm.$emit('back');
      }
    }
  }, [_vm._v("返回")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary",
    style: !_vm.canProceed ? {
      opacity: '0.6',
      cursor: 'not-allowed'
    } : {},
    attrs: {
      "disabled": !_vm.canProceed
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('next');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.textForNextStep) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }